import { Component } from '@angular/core';
import { ProgressComponent } from '@group24ag/flowkit';

@Component({
  selector: 'app-ui-progress',
  imports: [ProgressComponent],
  template: `
    <div class="flex flex-col gap-4">
      <h1 class="heading-title">Progress</h1>
      <div class="grid gap-6 md:grid-cols-2">
        <div class="space-y-2">
          <h2 class="text-sm font-medium">Variants</h2>
          <flk-progress [value]="25" />
          <flk-progress [value]="60" [variant]="'info'" />
          <flk-progress [value]="75" [variant]="'default'" />
          <flk-progress [value]="85" [variant]="'attention'" />
          <flk-progress [value]="100" [variant]="'warn'" />
        </div>

        <div class="space-y-2">
          <h2 class="text-sm font-medium">Magic</h2>
          <flk-progress variant="magic" [value]="25" />
          <flk-progress variant="magic" [value]="60" />
          <flk-progress variant="magic" [value]="75" />
          <flk-progress variant="magic" [value]="100" />
        </div>
      </div>

      <div class="grid gap-6 md:grid-cols-2">
        <div class="space-y-2">
          <h2 class="text-sm font-medium">Indeterminate</h2>
          <flk-progress [mode]="'indeterminate'" />
          <flk-progress [mode]="'indeterminate'" [variant]="'info'" />
          <flk-progress [mode]="'indeterminate'" [variant]="'default'" />
          <flk-progress [mode]="'indeterminate'" [variant]="'attention'" />
          <flk-progress [mode]="'indeterminate'" [variant]="'warn'" />
          <flk-progress [mode]="'indeterminate'" [variant]="'magic'" />
        </div>

        <div class="space-y-2">
          <h2 class="text-sm font-medium">Sizes</h2>
          <flk-progress size="xs" [mode]="'determinate'" [value]="5" />
          <flk-progress size="sm" [mode]="'determinate'" [value]="25" />
          <flk-progress size="md" [mode]="'determinate'" [value]="50" />
          <flk-progress size="lg" [mode]="'determinate'" [value]="75" />
        </div>
      </div>
    </div>
  `,
})
export class UIProgressComponent {}
